import { render } from "./edit_category.vue?vue&type=template&id=1b8455a0"
import script from "./edit_category.vue?vue&type=script&lang=js"
export * from "./edit_category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__